"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchDropdown = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var arrowUp = '"\\e92c"';
var arrowDown = '"\\e92a"';
var search = '"\\e997"';
exports.StyledSearchDropdown = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", ";\n  background-color: transparent;\n  position: relative;\n\n  &::before {\n    content: ", ";\n    visibility: visible;\n    font-family: IcoMinds-Font !important;\n    font-size: ", ";\n    position: absolute;\n    right: ", ";\n    z-index: 1;\n    pointer-events: none;\n    color: ", ";\n  }\n\n  &::after {\n    content: ", ";\n    visibility: visible;\n    font-family: IcoMinds-Font !important;\n    font-size: ", ";\n    position: absolute;\n    left: ", ";\n    top: 0;\n    z-index: 1;\n    pointer-events: none;\n    color: ", ";\n  }\n\n  input {\n    border: solid 1px\n      ", ";\n    border-radius: inherit;\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", ";\n    z-index: 2;\n    width: 100%;\n    outline: none;\n\n    &::focus {\n      outline: none;\n    }\n  }\n\n  ul {\n    box-shadow: 0 ", "\n      ", ";\n    visibility: ", ";\n    padding: 0;\n    margin: 0;\n    max-height: 120px;\n    overflow: auto;\n    width: 100%;\n    list-style: none;\n    border-radius: ", ";\n    z-index: 10;\n    position: absolute;\n\n    li {\n      ", ";\n      height: 40px;\n      padding: ", ";\n      color: ", ";\n      font-size: ", ";\n      background-color: ", ";\n\n      &:hover {\n        background-color: ", ";\n        cursor: pointer;\n      }\n    }\n  }\n\n  .spinner {\n    box-shadow: 0 ", "\n      ", ";\n    visibility: ", ";\n    height: calc(", " * 2.5);\n    width: 100%;\n    border-radius: ", ";\n    z-index: 10;\n    position: absolute;\n    background-color: ", ";\n    ", ";\n    flex-direction: column;\n  }\n"], ["\n  border-radius: ", ";\n  background-color: transparent;\n  position: relative;\n\n  &::before {\n    content: ", ";\n    visibility: visible;\n    font-family: IcoMinds-Font !important;\n    font-size: ", ";\n    position: absolute;\n    right: ", ";\n    z-index: 1;\n    pointer-events: none;\n    color: ", ";\n  }\n\n  &::after {\n    content: ", ";\n    visibility: visible;\n    font-family: IcoMinds-Font !important;\n    font-size: ", ";\n    position: absolute;\n    left: ", ";\n    top: 0;\n    z-index: 1;\n    pointer-events: none;\n    color: ", ";\n  }\n\n  input {\n    border: solid 1px\n      ", ";\n    border-radius: inherit;\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    padding: ", ";\n    z-index: 2;\n    width: 100%;\n    outline: none;\n\n    &::focus {\n      outline: none;\n    }\n  }\n\n  ul {\n    box-shadow: 0 ", "\n      ", ";\n    visibility: ", ";\n    padding: 0;\n    margin: 0;\n    max-height: 120px;\n    overflow: auto;\n    width: 100%;\n    list-style: none;\n    border-radius: ", ";\n    z-index: 10;\n    position: absolute;\n\n    li {\n      ", ";\n      height: 40px;\n      padding: ", ";\n      color: ", ";\n      font-size: ", ";\n      background-color: ", ";\n\n      &:hover {\n        background-color: ", ";\n        cursor: pointer;\n      }\n    }\n  }\n\n  .spinner {\n    box-shadow: 0 ", "\n      ", ";\n    visibility: ", ";\n    height: calc(", " * 2.5);\n    width: 100%;\n    border-radius: ", ";\n    z-index: 10;\n    position: absolute;\n    background-color: ", ";\n    ", ";\n    flex-direction: column;\n  }\n"])), function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.x4;
}, function (_a) {
    var open = _a.open;
    return (open ? arrowUp : arrowDown);
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.xl;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x3;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, search, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.xl;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x3;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Colors = _a.theme.Colors, value = _a.value;
    return ((0, isEmpty_1.default)(value) ? Colors.Borders.hint : Colors.primary);
}, function (_a) {
    var Colors = _a.theme.Colors, value = _a.value;
    return (0, isEmpty_1.default)(value) ? Colors.Borders.darkGray : Colors.primary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.fontFamiily;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x2, " ").concat(Spacing.x2, " ").concat(Spacing.x2, " ").concat(Spacing.x7);
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x1, " ").concat(Spacing.x1, " ").concat(Spacing.x1);
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Shadows.light;
}, function (_a) {
    var open = _a.open;
    return (open ? 'visible' : 'hidden');
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('vertical');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x2, " ").concat(Spacing.x4);
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.primary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Backgrounds.subtle;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x1, " ").concat(Spacing.x1, " ").concat(Spacing.x1);
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Shadows.light;
}, function (_a) {
    var open = _a.open;
    return (open ? 'visible' : 'hidden');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x7;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.white;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
});
var templateObject_1;
